// import { TableCell, TableHead, TableRow } from "@mui/material";
// import React from "react";
// import ImportExportIcon from "@mui/icons-material/ImportExport";
// import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
// import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

// const ShipmentReportTableHead = ({
//   coloumn,
//   handleRequestSort,
//   orderBy,
//   order,
// }) => {
//   const sortOptionColName = [
//     "Shipment Number",
//     "Origin Port Name",
//     "Destination Port Name",
//     "Consignee Name",
//     "Consignor Name",
//     "Cost",
//     "Container Numbers And Type",
//     "ATD",
//     "ATA",
//     "ETD",
//     "ETA",
//   "Origin UNLOCO",
//   "Origin Country",
//   "Destination UNLOCO",
//   "Destination Country",
//   "Origin Port Name",
//   "Destination Port Name",
//   "Shipment ETD",
//   "Shipment ETA",
//   "Carrier Name",
//   "Carrier Code",
//   "CO2 Emission Value (Kg)"
//   ];
//   const SortIcon = ({ value }) => {
//     if (sortOptionColName.includes(value)) {
//       if (order == value && orderBy == "asc") {
//         return (
//           <span>
//             <ArrowDownwardIcon />
//           </span>
//         );
//       } else if (order == value && orderBy == "desc") {
//         return (
//           <span>
//             <ArrowUpwardIcon />
//           </span>
//         );
//       }
//       return (
//         <span>
//           <ImportExportIcon />
//         </span>
//       );
//     }
//     return <></>;
//   };
//   return (
//     <TableHead>
//       <TableRow>
//         {coloumn?.map((col, index) => {
//           if (col?.value)
//             return (
//               <TableCell
//                 key={index}
//                 onClick={() => {
//                   if (sortOptionColName.includes(col?.displayColumnName)) {
//                     handleRequestSort(col?.displayColumnName);
//                   }
//                 }}
//               >
//                 {col?.displayColumnName}{" "}
//                 <SortIcon value={col?.displayColumnName} />
//               </TableCell>
//             );
//         })}
//       </TableRow>
//     </TableHead>
//   );
// };

// export default ShipmentReportTableHead;
// import { TableCell, TableHead, TableRow } from "@mui/material";
// import React from "react";
// import ImportExportIcon from "@mui/icons-material/ImportExport";
// import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
// import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

// const ShipmentReportTableHead = ({
//   coloumn,
//   handleRequestSort,
//   orderBy,
//   order,
// }) => {
//   const sortOptionColName = [
//     "Shipment Number",
//     "Origin Port Name",
//     "Destination Port Name",
//     "Consignee Name",
//     "Consignor Name",
//     "Cost",
//     "Container Numbers And Type",
//     "ATD",
//     "ATA",
//     "ETD",
//     "ETA",
//   "Origin UNLOCO",
//   "Origin Country",
//   "Destination UNLOCO",
//   "Destination Country",
//   "Origin Port Name",
//   "Destination Port Name",
//   "Shipment ETD",
//   "Shipment ETA",
//   "Carrier Name",
//   "Carrier Code",
//   "CO2 Emission Value (Kg)"
//   ];
//   const SortIcon = ({ value }) => {
//     if (sortOptionColName.includes(value)) {
//       if (order == value && orderBy == "asc") {
//         return (
//           <span>
//             <ArrowDownwardIcon />
//           </span>
//         );
//       } else if (order == value && orderBy == "desc") {
//         return (
//           <span>
//             <ArrowUpwardIcon />
//           </span>
//         );
//       }
//       return (
//         <span>
//           <ImportExportIcon />
//         </span>
//       );
//     }
//     return <></>;
//   };
//   return (
//     <TableHead>
//       <TableRow>
//         {coloumn?.map((col, index) => {
//           if (col?.value)
//             return (
//               <TableCell
//                 key={index}
//                 onClick={() => {
//                   if (sortOptionColName.includes(col?.displayColumnName)) {
//                     handleRequestSort(col?.displayColumnName);
//                   }
//                 }}
//               >
//                 {col?.displayColumnName}{" "}
//                 <SortIcon value={col?.displayColumnName} />
//               </TableCell>
//             );
//         })}
//       </TableRow>
//     </TableHead>
//   );
// };

// export default ShipmentReportTableHead;
import { TableCell, TableHead, TableRow } from "@mui/material";
import React from "react";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

const ShipmentReportTableHead = ({ coloumn, handleRequestSort, orderBy, order }) => {
  // Mapping specific columns to their API field names
  const specialColumnMapping = {
    "Shipment ETD": "shipmentOriginETD",       // Custom mapping
    "Shipment ETA": "shipmentDestinationETA",  // Custom mapping
    "CO2 Emission Value (Kg)": "totalAmount",  // Custom mapping
  };

  // List of sortable column display names
  const sortOptionColName = [
    "Shipment Number",
    "Origin Port Name",
    "Destination Port Name",
    "Consignee Name",
    "Consignor Name",
    "Cost",
    "Container Numbers And Type",
    "ATD",
    "ATA",
    "ETD",
    "ETA",
    "Origin UNLOCO",
    "Origin Country",
    "Destination UNLOCO",
    "Destination Country",
    "Origin Port Name",
    "Destination Port Name",
    "Shipment ETD",
    "Shipment ETA",
    "CO2 Emission Value (Kg)",
    "Carrier Name",
    "Carrier Code",
    "Shipment Number",
    "Shipper Name",
  ];

  // Component to render sort icons based on sorting state
  // const SortIcon = ({ value }) => {
  //   if (sortOptionColName.includes(value)) {
  //     if (order === value && orderBy === "asc") {
  //       return <ArrowDownwardIcon />;
  //     } else if (order === value && orderBy === "desc") {
  //       return <ArrowUpwardIcon />;
  //     }
  //     return <ImportExportIcon />;
  //   }
  //   return null;
  // };
  const SortIcon = ({ value }) => {
    if (sortOptionColName.includes(value)) {
      if (order === specialColumnMapping[value] || order === value) {
        return orderBy === "asc" ? <ArrowUpwardIcon /> : <ArrowDownwardIcon />;
      }
      return <ImportExportIcon />;
    }
    return null;
  };
  return (
    <TableHead>
      <TableRow>
        {coloumn?.map((col, index) => {
          if (col?.value) {
            return (
              <TableCell
                key={index}
                onClick={() => {
                  // Check if the column is sortable
                  if (sortOptionColName.includes(col?.displayColumnName)) {
                    // Get the corresponding API field name if it exists in specialColumnMapping
                    const apiFieldName = specialColumnMapping[col?.displayColumnName] || col?.displayColumnName;
                    // Call handleRequestSort with the API field name
                    handleRequestSort(apiFieldName);
                  }
                }}
              >
                {col?.displayColumnName} <SortIcon value={col?.displayColumnName} />
              </TableCell>
            );
          }
          return null;
        })}
      </TableRow>
    </TableHead>
  );
};

export default ShipmentReportTableHead;
